<template>
  <div>
    <div v-show="shouldDisplay">
      <div class="md-card md-card-tabs">
        <h4 class="md-card-header font_bold">{{title2}}</h4>
        <div class="md-card-content">
          <div v-show="hasData" class="chart" ref="myEchartPillar" style="height:400px"></div>
          <emptyChart v-show="!hasData"></emptyChart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from "vuex";
  import EmptyChart from "@/views/dashboard/EmptyChart";

  export default {
  props: {
    showTitle: { type: Boolean, default: true },
    activeRate: String
  },
  components: {
    EmptyChart
  },
  data() {
    return {
      option: {},
      title: this.$t("dashboard.ExpectedColumnar.title1"),
      title2: this.$t("dashboard.ExpectedColumnar.title2"),
      shouldDisplay: true,
      hasData: true
    };
  },
  methods: {
    setOption() {
      var xAxis = [-1];
      let currentMonth = moment().month() + 1;
      for (let i = 0; i < 12; i++) {
        xAxis.push( currentMonth + i)
      }
      this.option = {
        color: ["#0071EB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value"
          }
        ],
        series: [
          {
            name: this.$t('dashboard.ExpectedColumnar.infoText'),
            type: "bar",
            data: [10, 52, 200, 334, 390, 330, 220, 220, 220, 220, 220, 220, 1],
            itemStyle: {
              normal: {
                color: function(params) {
                  // build a color map as your need.
                  var colorList = ["#FE766C", "#0071EB"];
                  if (params.dataIndex === 0) {
                    return colorList[0];
                  } else {
                    return colorList[1];
                  }
                }
              }
            }
          }
        ]
      };
    },
    shouldSetData() {
      return this.shouldDisplay && this.$refs.myEchartPillar
    },
    setData() {
      let currentYear = moment().year();
      let currentYearString =currentYear.toString();
      let nextYearString = (currentYear + 1).toString();

      this.setOption();
      let option = this.option;
      let myChart = echarts.init(this.$refs.myEchartPillar);
      let xAxisData = option.xAxis[0].data;

      xAxisData = xAxisData.map(item => {
        if (item > 0 && item < 13) {
          item = currentYearString + "-" + item;
        } else if (item > 0 && item >=13) {
          item = nextYearString +  "-" + (item%12).toString();
        } else {
          item = "Overdue";
        }
        return item;
      });
      option.xAxis[0].data = xAxisData;

      // monthly,overdue
      let monthlyData = [];
      let yAxisLeft = option.yAxis[0];
      let dataAvailable = false;
      let { statisticData } = this.dashboardInfo;
      if (statisticData.expectedCashflows) {
        const { monthly, overdue } = statisticData.expectedCashflows;

        if ((monthly && monthly.length >0) || (overdue && overdue.totalExpectedCashflow)) {
          dataAvailable = true;
        }
        overdue.totalExpectedCashflow=overdue.totalOverdueCashflow;
        monthlyData.push(overdue);
        monthlyData = [...monthlyData, ...monthly];
        let totalExpectedCashflowSort = [];
        option.series[0].data = monthlyData.map(item => {
          return item.totalExpectedCashflow;
        });
        totalExpectedCashflowSort = monthlyData.sort(function(a, b) {
          return a.totalExpectedCashflow - b.totalExpectedCashflow;
        });

        if (totalExpectedCashflowSort && totalExpectedCashflowSort.length > 0) {
          yAxisLeft.min = totalExpectedCashflowSort[0].totalExpectedCashflow;
          yAxisLeft.max =
            totalExpectedCashflowSort[totalExpectedCashflowSort.length - 1].totalExpectedCashflow;
          yAxisLeft.interval = Math.floor(
            (totalExpectedCashflowSort[totalExpectedCashflowSort.length - 1].totalExpectedCashflow -
              totalExpectedCashflowSort[0].totalExpectedCashflow) /
              5
          );
        }
        myChart.setOption(option);
        setTimeout(function() {
          window.addEventListener("resize", () => {
            myChart.resize();
          });
        }, 500);
      }
      this.hasData = dataAvailable;
    }
  },
  computed: {
    ...mapGetters({
      dashboardInfo: "dashboardInfo",
      dashboardFilter: "dashboardFilter"
    })
  },
  watch: {
    dashboardInfo() {
      let { years } = this.dashboardFilter;
      this.shouldDisplay = moment().year() === years;
      if (this.shouldSetData()) {
        this.setData();
      }
    }
  }
};
</script>